import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';
// import {Table} from 'antd'
// import { Checkbox } from 'antd';
import CustomCell from '../../../pages/universalDetails/niinDetailTables/subcomponents/CustomItemCell';
import Header from '../../../pages/universalDetails/niinDetailTables/subcomponents/Header';
import WSCodes from '../../../config/SegCCodeDef.json';

import './Drawings.scss';

export default class ProcurementHistoryGrid extends React.PureComponent {
  static propTypes = {
    data: PropTypes.array.isRequired,
  };

  render() {
    const { data } = this.props;

    const column = [
      {
        Header: 'Weapons System Name',
        accessor: 'wsName',
      },
      {
        Header: 'WSDC',
        accessor: 'wsdc',
      },

      {
        Header: <Header title="WSEC" tooltip={WSCodes.WSEC.definition} />,
        accessor: 'wsec',
        Cell: cellProps => <CustomCell type="WSEC" value={cellProps.value} />,
      },

      {
        Header: <Header title="WSIC" tooltip={WSCodes.WSIC.definition} />,
        accessor: 'wsic',
        Cell: cellProps => <CustomCell type="WSIC" value={cellProps.value} />,
      },

      {
        Header: <Header title="WSGC" tooltip={WSCodes.WSGC.definition} />,
        accessor: 'wsgc',
        Cell: cellProps => <CustomCell type="WSGC" value={cellProps.value} />,
      },
    ];

    return (
      <div className="nf-drawings__grid">
        <ReactTable
          data={data}
          columns={column}
          defaultPageSize={data.length < 5 ? data.length : 5}
          showPagination={data.length > 5}
          style={{ textAlign: 'center' }}
        />
        {/* <Table dataSource={drawings} columns={columns} /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/WSDCGrid/DrawingsGrid.jsx